import React from "react";

interface TargetsThreadProps {
  width?: number;
  height?: number;
  className?: string;
  stroke?: string;
  showConnector?: boolean;
}

const ThreadConnector: React.FC<TargetsThreadProps> = ({
  width = 15,
  height = 70,
  className,
  stroke = "#DCE4E9",
  showConnector = true,
}) => {
  // Calculate the path based on the actual height and showConnector prop
  const straightLineEnd = height - 13; // Leave 13px for the curve
  const curveEnd = height;

  // Dynamic path that adjusts to height and connector visibility
  const dynamicPath = showConnector
    ? `M1 0V${straightLineEnd}M1 ${straightLineEnd}C1 ${
        straightLineEnd + 6.3
      } 6.37 ${curveEnd} 13 ${curveEnd}` // Full line with connector
    : `M1 0V${height}`; // Just straight vertical line

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d={dynamicPath} stroke={stroke} />
    </svg>
  );
};

export default ThreadConnector;
